/* eslint-disable react/no-array-index-key */
import React from "react"

import { BreadcrumbItem, BreadcrumbItemProps } from "./BreadcrumbItem"
import { BreadcrumbWrapper } from "./BreadcrumbWrapper"

export interface BreadcrumbProps {
  loadingItemAmount?: number
  isLoading?: boolean
  breadcrumbItems: Omit<BreadcrumbItemProps, "isActive">[] | null
}

export const Breadcrumb = React.memo(
  ({ breadcrumbItems, isLoading, loadingItemAmount = 3 }: BreadcrumbProps) => (
    <BreadcrumbWrapper
      isLoading={isLoading}
      loadingItemAmount={loadingItemAmount}
    >
      {breadcrumbItems?.map((breadcrumbProps, index) => (
        <BreadcrumbItem
          key={index}
          {...breadcrumbProps}
          isActive={index === (breadcrumbItems?.length || 0) - 1}
        />
      ))}
    </BreadcrumbWrapper>
  )
)
